<template>
  <!--   This component just builds the appropriate html / css framework
  for a lazy scroller on the x and y axis. It does not provide any logic
  and is just a rendering template
 -->
  <div
    ref="main"
    :class="merged_scroll_container_classes"
    @[maybescroll]="scroll_handler"
  >
    <div
      class="synaplus-cosmo-scroll-containee"
      :class="scroll_containee_class"
      :style="container_style"
    >
      <!--       This component was needed when using an HTML table
      but is no longer useful
 -->
      <component :is="container" ref="dyncomp" :class="container_class">
        <template v-if="renderx.initialized">
          <component
            :is="rendery.container"
            v-for="nby in _.range(
              rendery.component_start,
              rendery.component_stop
            )"
            :key="`r${nby}`"
            :class="rendery.container_class"
          >
            <component
              :is="renderx.container"
              v-for="nbx in _.range(
                renderx.component_start,
                renderx.component_stop
              )"
              :key="`r${nby}xc${nbx}`"
              :class="renderx.container_class"
            >
              <slot
                name="default"
                :nbx="nbx"
                :nby="nby"
                :initialized="true"
              ></slot>
            </component>
          </component>
        </template>
        <template v-else>
          <component
            :is="rendery.container"
            key="r0"
            :class="rendery.container_class"
          >
            <component
              :is="renderx.container"
              key="r0xc0"
              :class="renderx.container_class"
            >
              <slot
                name="default"
                :nbx="0"
                :nby="0"
                :initialized="false"
              ></slot>
            </component>
          </component>
        </template>
      </component>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

// *****************************************************************************

export default {
  name: 'LazyTableXy',
  props: [
    'container',
    'container_class',
    'renderx',
    'rendery',
    'scroll_container_class',
    'scroll_containee_class',
  ],
  computed: {
    _() {
      return _
    },
    maybescroll() {
      const res = this.renderx.scroll || this.rendery.scroll ? '&scroll' : null
      return res
    },
    merged_scroll_container_classes() {
      let scroll_container_classes = ['synaplus-cosmo-scroll-container']
      if (this.renderx.scroll) {
        scroll_container_classes.push('synaplus-cosmo-add-scrollbar-x')
      } else {
        scroll_container_classes.push('synaplus-cosmo-no-scrollbar-x')
      }
      if (this.rendery.scroll) {
        scroll_container_classes.push('synaplus-cosmo-add-scrollbar-y')
      } else {
        scroll_container_classes.push('synaplus-cosmo-no-scrollbar-y')
      }
      // Special syntax to merge classes
      return scroll_container_classes.concat(this.scroll_container_class)
    },
    container_style() {
      return {
        'padding-left': `${this.renderx.padding_low}px`,
        'padding-right': `${this.renderx.padding_high}px`,
        width: `${this.renderx.really_rendered_size}px`,
        'padding-top': `${this.rendery.padding_low}px`,
        'padding-bottom': `${this.rendery.padding_high}px`,
        height: `${this.rendery.really_rendered_size}px`,
      }
    },
  },
  mounted() {
    if (!this.renderx.initialized) {
      this.$emit('initialize', this.$refs.main, this.$refs.dyncomp.firstChild)
    }
  },
  updated() {
    this.$emit('updated')
  },
  methods: {
    scroll_handler(evt) {
      this.$emit('scrollxy', evt)
    },
  },
}
</script>
